module.exports = __webpack_public_path__ + "static/2016-B16-e9a0b7935c3a462b5fa1f075651a7aca.pdf";